import { v4 as uuidv4 } from 'uuid';
import { createPureImageGridUtils } from './pureImageGrid.js';

const grid = createPureImageGridUtils({
	type: 'pay-image-gallery',
	colCount: 3,
	colGap: 5,
	defaultHeight: 110,
	defaultBorderRadius: 8,
	defaultItemCount: 9,
	imageIdPrefix: 'pay-image-gallery-item',
	randomStart: 201,
	assetKey: 'payImageGallery',
});

export const PAY_IMAGE_GALLERY_TYPE = grid.TYPE;
export const PAY_IMAGE_GALLERY_COL_COUNT = grid.COL_COUNT;
export const PAY_IMAGE_GALLERY_COL_GAP = grid.COL_GAP;
export const PAY_IMAGE_GALLERY_DEFAULT_HEIGHT = grid.DEFAULT_HEIGHT;
export const PAY_IMAGE_GALLERY_BATCH_SIZE = grid.BATCH_SIZE;

export const DEFAULT_PAY_IMAGE_GALLERY_FEATURES = [
	{ id: uuidv4(), text: '高清无水印', icon: 'check' },
	{ id: uuidv4(), text: '支持下载', icon: 'download' },
	{ id: uuidv4(), text: '永久有效', icon: 'shield' },
];

function getFixedFeatures() {
	return DEFAULT_PAY_IMAGE_GALLERY_FEATURES.map(item => ({ ...item, id: uuidv4() }));
}

function normalizePayFields(data = {}) {
	const freePreviewCount = Number(data.freePreviewCount);
	const gridData = grid.normalizeData(data);

	return {
		title: data.title || '唯美风景壁纸合集',
		subtitle: data.subtitle || `共 ${gridData.items.length} 张精选高清壁纸`,
		features: getFixedFeatures(),
		price: data.price ?? '3.90',
		currency: data.currency || '¥',
		buttonText: data.buttonText || '立即解锁',
		buttonBg: data.buttonBg || data.buttonBgStart || '#ff4d4f',
		freePreviewCount: Number.isFinite(freePreviewCount) && freePreviewCount >= 0
			? Math.min(freePreviewCount, gridData.items.length)
			: 3,
		...gridData,
		fullWidth: true,
	};
}

export function getPayImageGalleryDefaults(extra = {}) {
	return normalizePayFields({
		items: grid.createDefaultItems(9),
		...extra,
	});
}

export function normalizePayImageGalleryData(data = {}) {
	return normalizePayFields(data);
}

export function isPayImageGalleryBlock(type) {
	return type === PAY_IMAGE_GALLERY_TYPE;
}

export const createDefaultPayImageGalleryItem = grid.createDefaultItem;
export const createDefaultPayImageGalleryItems = grid.createDefaultItems;
export const getPayImageGalleryImageUrl = grid.getImageUrl;
export const getPayImageGalleryBlockStyle = grid.getBlockStyle;
export const getPayImageGalleryGalleryUrls = grid.getGalleryUrls;
export const getPayImageGalleryThumbAspectRatio = grid.getThumbAspectRatio;

export function getPayImageGalleryUnlockKey(blockId) {
	return blockId ? `gedit-pay-unlock-${blockId}` : '';
}

export function isPayImageGalleryUnlocked(blockId) {
	const key = getPayImageGalleryUnlockKey(blockId);
	if (!key || typeof sessionStorage === 'undefined') return false;
	return sessionStorage.getItem(key) === '1';
}

export function setPayImageGalleryUnlocked(blockId, unlocked = true) {
	const key = getPayImageGalleryUnlockKey(blockId);
	if (!key || typeof sessionStorage === 'undefined') return;
	if (unlocked) {
		sessionStorage.setItem(key, '1');
	} else {
		sessionStorage.removeItem(key);
	}
}
